import { Box, SimpleGrid, Heading, List, ListItem } from "@chakra-ui/react";

const ServiceGrid = () => {
  return (
    <Box color={"black"} px={4} bg="gray.50">
      <Box maxW="600px" mx="auto">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          
          {/* HAFRİYAT */}
          <Box>
            <Heading as="h3" size="md" mb={3}>
              Çanakkale Hafriyat
            </Heading>
            <List spacing={1} textDecoration={"underline"} fontSize="sm">
              <ListItem>Çanakkale moloz taşıma</ListItem>
              <ListItem>Çanakkale inşaat malzemesi taşıma</ListItem>
              <ListItem>Çanakkale kum taşıma</ListItem>
              <ListItem>Çanakkale stabilize malzeme nakliyesi</ListItem>
              <ListItem>Çanakkale şantiye malzemeleri taşıma</ListItem>
              <ListItem>Çanakkale dökme yük malzemeleri taşıma</ListItem>
            </List>
          </Box>

          {/* NAKLİYE */}
          <Box>
            <Heading as="h3" size="md" mb={3}>
              Çanakkale Nakliye
            </Heading>
            <List textDecoration={"underline"} spacing={1} fontSize="sm">
              <ListItem>Çanakkale yük nakliyesi</ListItem>
              <ListItem>Çanakkale kamyon nakliye</ListItem>
              <ListItem>Çanakkale kamyonet nakliye</ListItem>
              <ListItem>Çanakkale şehir içi nakliye</ListItem>
              <ListItem>Çanakkale şehirler arası nakliye</ListItem>
            </List>
          </Box>

        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default ServiceGrid;
